import React, { Component } from 'react';
import { Tree, Icon, Input, Select } from 'antd';
import _ from 'lodash';
import styled from 'styled-components';
import Button from '../../../views/StyledButton';

import catapultStore from './catapultStore';
import { FormRow } from '../../../views/Form';
import { GREEN, GRAY } from '../../../views/styleConstants';
import { HelpText } from '../../../views/typography';

const FOLDER = <Icon type="folder" theme="twoTone" twoToneColor={GREEN} />;

const NoFilter = styled.span`
  
`;

export default class CatapultContainer extends Component {
  constructor(props) {
    super(props);
    this.store = catapultStore(props.token);
    this.state = { ...this.store.state };
  }

  componentDidMount() {
    console.log('cat --> did mount: subscribing');
    this._stateSub = this.store.subscribe(
      ({ state }) => {
        this.setStateSafely({ ...state });
      },
      (err) => {
        console.log('catapult state error: ', err);
      }, () => {
        this._stateSub.unsubscribe();
      },
    );
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this._stateSub) {
      this._stateSub.unsubscribe();
    }
  }

  /**
   * sets state if the component has not been unmounted.
   * returns a promise tied into setState (or auto-completes if no set state call)
   * @param change
   * @param onDone
   * @returns {Promise<any>}
   */
  setStateSafely(change, onDone) {
    return new Promise((done) => {
      if (!this.unmounted) {
        this.setState(change, () => {
          if (_.isFunction(onDone)) {
            onDone();
          }
          done();
        });
      } else {
        if (_.isFunction(onDone)) {
          onDone();
        }
        done();
      }
    });
  }

  treeToNodes(props) {
    const {
      title, key, children, link, folder,
    } = props;
    const nodeTitle = link ? (<a
      size="small"
      onClick={() => {
      this.props.onChooseFilter(key);
    }}
      type="link"
    >{title}
                              </a>) : title;
    if (!_.get(children, 'length')) {
      return <Tree.TreeNode selectable={false} title={nodeTitle} key={key || title} />;
    }

    return (
      <Tree.TreeNode selectable={false} title={nodeTitle} key={key || title} icon={!folder ? '' : FOLDER}>
        {children.map(child => this.treeToNodes(child))}
      </Tree.TreeNode>
    );
  }

  render() {
    const { state, actions } = this.store;
    const {
      catTree, searchString, tags, tagFilter, treeExpanded,
    } = state;
    if (!catTree) {
      return '---loading tree--';
    }

    return (
      <div>
        <div style={({ padding: '0.5rem' })} >
          <Input.Search placeholder="Search" value={searchString} onChange={actions.chooseSearchString} />
        </div>
        {/*
        <div style={({ padding: '0.5rem' })} >
          <div>Filter by tag:</div>
          <Select value={tagFilter == ' ' ? 'No filter' : tagFilter} placeholder="No filter" style={({ width: '100%' })} maxTagCount={10} onChange={actions.chooseTagFilter}>
            <Select.Option key=" ">No filter</Select.Option>
            {tags.map(tag => <Select.Option key={tag}>{tag}</Select.Option>)}
          </Select>
        </div>
        */}
        <Tree blockNode defaultExpandAll showIcon switcherIcon={<Icon type="down" />}
              expandedKeys={treeExpanded}
              onExpand={actions.setExpanded}
        >
          {this.treeToNodes({
            title: 'Filters', key: 'root', children: catTree, folder: true,
          })}
        </Tree>
      </div>
    );
  }
}
